import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { IComponentProps } from "../../utils/commonTypes";

export const UiStateContainer: React.FC<IComponentProps> = props => {
    return <>{props.uiState.visible !== false && webui.getUtils().resolveChildren(props)}</>;
};

export default webui.connectComponent({ uiState: true })(UiStateContainer);
